/**
 * ShowLength.js
 * 
 * Displays the current segment length while drawing.
 * Converts distance to feet and inches (e.g., 12' 4").
 */

import { DrawingGlobals, LABELS } from "../../Global/variables";
import * as THREE from "three";

export function showLength(point) {
    // Ensure label exists
    if (!LABELS.length || !LABELS.length.element) return;

    const points = DrawingGlobals.intersectionPoints;
    if (points.length < 1) return;

    // ✅ Use the last placed point as the start of the segment
    const start = points[points.length - 1];
    const distanceMeters = start.distanceTo(point);

    // Convert meters → feet
    const totalFeet = distanceMeters * 3.28084;

    // Split into whole feet and inches
    const feet = Math.floor(totalFeet);
    const inches = Math.round((totalFeet - feet) * 12);

    // Handle rounding edge case (e.g., 12 inches = +1 foot)
    const displayFeet = inches === 12 ? feet + 1 : feet;
    const displayInches = inches === 12 ? 0 : inches;

    // Update label text and make visible
    LABELS.length.visible = true;
    LABELS.length.element.innerText = `${displayFeet}' ${displayInches}"`;

    // Position halfway between start and current point  
    LABELS.length.position.lerpVectors(start, point, 0.5);
}
